import { type SchoolImage } from '@/mocks/overseasImages';

type Props = { image: SchoolImage; schoolName: string; officialUrl: string; alt: string; className?: string };

export default function SourcedImage({ image, schoolName, officialUrl, alt, className }: Props) {
  return (
    <figure className={className}>
      <img src={image.file} alt={alt} loading="lazy" className="w-full h-[240px] md:h-[300px] object-cover object-center bg-background-100" />
      <figcaption className="mt-2 text-[12px] leading-relaxed text-foreground-500 tracking-[0.02em]">
        出典: <a href={officialUrl} target="_blank" rel="noopener noreferrer" className="underline hover:text-accent-600">{schoolName} 公式サイト</a>
        <span className="block break-all text-foreground-400">{image.sourceUrl}</span>
      </figcaption>
    </figure>
  );
}
